import VisitaAngiologicaList from "./pages/VisitaAngiologicaList.vue"

export default {
    VisitaAngiologicaList,
};
